<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue';
import Lenis from 'lenis';
import { setLenis } from '~/utils/lenis';

// Plain variable (not a ref): the instance isn't used in the template, and a ref
// would deep-unwrap and break the Lenis class type.
let lenis: Lenis | null = null;

onMounted(() => {
  // Don't hijack scrolling for users who prefer reduced motion.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  lenis = new Lenis({
    autoRaf: true,
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    autoToggle: true,
    syncTouch: false,
  });

  // Expose it so the router can reset scroll through Lenis on navigation.
  setLenis(lenis);
});

onBeforeUnmount(() => {
  if (lenis) {
    lenis.destroy();
    setLenis(null);
  }
});
</script>
